
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { debounce } from "typescript-debounce-decorator";
import httpClient from "../../store/httpClient";
import moment from "moment";
import DatePicker from "../../components/DatePicker.vue";
import ArticleCadPreview from "@/components/ArticleCadPreview.vue";
import EditAddressComponent from "@/components/EditAddressComponent.vue";
import store from "../../store/store";
import { CustomerOrderDto } from "../../dtos/customerOrderDto";
import { ErpCustomerOrderState } from "../../dtos/erpCustomerOrderState";
import { AddressDto } from "@/dtos/addressDto";
import { AddressType } from "@/dtos/addressType";
import { OrderSearchRequestDto } from "@/dtos/orderSearchRequestDto";
import { OrderSortingType } from "@/dtos/orderSortingType";
import ArticleFaceTypes from "@/dtos/IArticleFaceTypes";
import { IArticleFaceType } from "@/dtos/IArticleFaceTypes";
import PowderFinishes from "@/dtos/IPowderFinish";
import { IPowderFinish } from "@/dtos/IPowderFinish";
import PowderStructures from "@/dtos/IPowderStructure";
import { IPowderStructure } from "@/dtos/IPowderStructure";
import { WorkStepDto } from "@/dtos/workStepDto";
import { ArticleDto } from "@/dtos/articleDto";
import PriceModelDefault from "@/dtos/priceModel";
import { getEntgratartText } from "@/dtos/entgratart";
import { PartDto } from "@/dtos/partDto";
import OrderCalculationComponent from "@/components/OrderCalculationComponent.vue";
import EditTransportDialog from "@/components/EditTransportDialog.vue";
import { getZincCoatingText, ZincCoating } from "@/dtos/zincCoating";
import CreatePrepayInvoiceDialog from "./CreatePrepayInvoiceDialog.vue";
import CreateCreditNoteDialog from "@/components/CreateCreditNoteDialog.vue";

@Component({
	components: {
		DatePicker,
		ArticleCadPreview,
		EditAddressComponent,
		OrderCalculationComponent,
		EditTransportDialog,
		CreatePrepayInvoiceDialog,
		CreateCreditNoteDialog,
	},
})
export default class OrderDashboard extends Vue {
	@Prop()
	private articleId!: string;
	private articleSearchTerm: string = "";
	private quantityOfASinglePositionGreaterThen: number = 0;
	private numberOfPositionsLessThen: number = 0;
	private showAnalyseFilters: number = 0;
	private loading: boolean = false;
	private orders: CustomerOrderDto[] = [];
	private editAddressDialog: boolean = false;
	private currentEditedAddress: AddressDto = new AddressDto();
	private currentEditedAddressType: AddressType = AddressType.OrderInvoice;
	private currentEditedOrderId: number = 0;
	private currentTrackingLink: string = "";
	private trackingLinkDialog: boolean = false;
	private loadBatchSize: number = 50;
	private hasMoreToLoad: boolean = true;
	private articleFaceTypes: IArticleFaceType[] = ArticleFaceTypes;
	private powderFinishes: IPowderFinish[] = PowderFinishes;
	private powderStructures: IPowderStructure[] = PowderStructures;
	private showCancellationAtFertigerDialog: boolean = false;
	private currentCancellationRequest: any = null;
	private currentOrderWorkSteps: any = [];
	private currentOrderArticleMaterials: Map<number, string> = new Map<number, string>();
	private showOrderWorkStepsDialog: boolean = false;
	private sendOrderConfirmationDialog: boolean = false;
	private getEntgratartText = getEntgratartText;
	private releaseOrderDialog: boolean = false;
	private currentOrderId: number = 0;
	private currentOrderFertigerId: number = 0;
	private currentOrderSendConfirmation: boolean = true;
	private currentOrderSendDirectlyToCustomer: boolean = true;
	private cancelOrderDialog: boolean = false;
	private currentCancelOrderId: string = "";
	private currentCancelOrderFertigerId: number = 0;
	private showModifyTransportDialog: boolean = false;
	private currentModifyTransportOrder: CustomerOrderDto | null = null;
	private prepayInvoiceDialogOpen: boolean = false;
	private orderIdForPrepayInvoice: number = 0;
	private creditNoteDialogOpen: boolean = false;
	private creditNoteOrderId: number = 0;
	private creditNoteCustomerId: number = 0;

	/**
	 * Wird temporär benutzt, um die möglichen Fertiger anzuzeigen, wenn ein Fertiger nicht
	 * möglich ist.
	 */
	private possibleFertigers: any = [];
	private showPossibleFertigersDialog: boolean = false;
	private headers: Array<{
		text: string;
		value: string;
		align: string;
		sortable: boolean;
	}> = Array(
		{
			text: "Status",
			value: "customerOrderState",
			align: "left",
			sortable: true,
			width: "1px",
		},
		{
			text: "KndNr",
			value: "customerId",
			align: "left",
			sortable: true,
			width: "1px",
		},
		{
			text: "Name",
			value: "customerName",
			align: "left",
			sortable: true,
			width: "1px",
		},
		{
			text: "AufragsNr",
			value: "orderId",
			align: "left",
			sortable: true,
			width: "1px",
		},
		{
			text: "Gewicht",
			value: "totalWeight",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Eingegangen am",
			value: "receivedAt",
			align: "left",
			sortable: true,
			width: "1px",
		},
		{
			text: "Liefertermin",
			value: "dueDate",
			align: "left",
			sortable: true,
			width: "1px",
		},
		{
			text: "Fertiger",
			value: "fertigerId",
			align: "left",
			sortable: true,
			width: "1px",
		},
		{
			text: "",
			value: "",
			align: "right",
			sortable: false,
			width: "0px",
		}
	);

	private positionHeader: Array<{
		text: string;
		value: string;
		align: string;
		sortable: boolean;
		width: string;
	}> = Array(
		{
			text: "Pos",
			value: "position",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Blexon Id",
			value: "articleId",
			align: "left",
			sortable: false,
			width: "60px",
		},
		{
			text: "",
			value: "empty",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Bezeichnung",
			value: "description",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Eigenschaften",
			value: "attributes",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Menge",
			value: "amount",
			align: "left",
			sortable: false,
			width: "1px",
		},
		{
			text: "Preis",
			value: "price",
			align: "right",
			sortable: false,
			width: "1px",
		},
		{
			text: "Total",
			value: "total",
			align: "right",
			sortable: false,
			width: "1px",
		}
	);

	beforeRouteEnter(to: any, from: any, next: any) {
		next((vm: any) => {
			window.addEventListener("scroll", vm.checkBottom);
		});
	}

	beforeRouteLeave(to: any, from: any, next: any) {
		window.removeEventListener("scroll", this.checkBottom);
		next();
	}

	private created() {
		if (this.articleId != null) {
			this.articleSearchTerm = this.articleId;
		}
	}

	private mounted() {
		if (this.orders.length <= 0) {
			this.loadOrders(true);
		}
		if (this.orderCancellationRequests == null) {
			this.loadOrderCancellationRequests();
		}
	}

	private openTransportProviderDialog(order: CustomerOrderDto) {
		this.currentModifyTransportOrder = order;
		this.showModifyTransportDialog = true;
	}

	private onModifyTransportDialogClosed(reload: boolean) {
		this.showModifyTransportDialog = false;
		if (reload) {
			this.orderSearchTerm = this.currentModifyTransportOrder!.orderId;
			this.loadOrders(true);
		}
	}

	private isModifyTransportOptionShown(order: CustomerOrderDto) {
		return (
			order.customerOrderState === ErpCustomerOrderState.Gueltig ||
			order.customerOrderState === ErpCustomerOrderState.Freigegeben ||
			order.customerOrderState === ErpCustomerOrderState.Fertig ||
			order.customerOrderState === ErpCustomerOrderState.CreditOverdrawn
		);
	}

	private get orderSearchTerm() {
		return (store.state as any).orderSuchbegriff;
	}
	private set orderSearchTerm(orderSearchTerm: string) {
		store.commit("setOrderSuchbegriff", orderSearchTerm);
	}

	private get orderCancellationRequests() {
		return this.$store.state.orderCancellations;
	}

	private get orderStates() {
		const states = [
			{ value: ErpCustomerOrderState.Gueltig, name: "Bestellt" },
			{ value: ErpCustomerOrderState.Freigegeben, name: "In Produktion" },
			{ value: ErpCustomerOrderState.Fertig, name: "Fertig" },
			{ value: ErpCustomerOrderState.Geliefert, name: "In Lieferung" },
			{ value: ErpCustomerOrderState.Fakturiert, name: "Fakturiert" },
			{ value: ErpCustomerOrderState.Abgeschlossen, name: "Bezahlt" },
			{ value: ErpCustomerOrderState.Storniert, name: "Storniert" },
			{ value: ErpCustomerOrderState.CreditOverdrawn, name: "Kreditlimit überschritten" },
			{ value: ErpCustomerOrderState.InStornierung, name: "In Stornierung" },
		];
		return states;
	}

	private get filterStates(): any[] {
		return this.$store.state.orderFilterStates;
	}
	private set filterStates(states: any[]) {
		this.$store.commit("setOrderFilterStates", states);
	}

	private get filterFertiger(): any[] {
		return this.$store.state.orderFilterFertiger;
	}
	private set filterFertiger(fertiger: any[]) {
		this.$store.commit("setOrderFilterFertiger", fertiger);
	}

	private getPositionHeaders(item: CustomerOrderDto) {
		let headers = JSON.parse(JSON.stringify(this.positionHeader));
		headers.filter((h: any) => h.text === "Preis")[0].text =
			`Preis [${PriceModelDefault.getPriceModelText(item.priceModel)}]`;
		return headers;
	}

	private customSort(items: any, index: any, isDesc: any) {
		// Do nothing because items are correclty sorted by the backend
		// But a custom sort is needed because otherwise the data-table shuffles items around
		// Maybe there is another solution to stop the sorting but I haven't found it, yet.
		return items;
	}

	private get fertigers() {
		return store.state.fertigers;
	}

	private get fertigerPortalLink() {
		let fertigerId = this.orders.filter(
			(o: CustomerOrderDto) => o.orderId == this.currentCancellationRequest.blexonOrderId
		)[0].fertigerId;
		let fertigerUrlId = this.$store.state.fertigers.filter((f: any) => f.id == fertigerId)[0]
			.dbId;
		return `${process.env.VUE_APP_FERTIGERPORTAL_URL}#/${fertigerUrlId}/cancellation/${this.currentCancellationRequest.blexonOrderId}`;
	}

	@debounce(700, { leading: false })
	@Watch("articleSearchTerm")
	private reloadOnArticleSearch() {
		if (this.articleSearchTerm.length === 0 || this.articleSearchTerm.length >= 3)
			this.loadOrders(true);
	}
	@debounce(700, { leading: false })
	@Watch("orderSearchTerm")
	private reloadOnOrderSearch() {
		if (this.orderSearchTerm.length === 0 || this.orderSearchTerm.length >= 3)
			this.loadOrders(true);
	}

	private onEnterClickInSearchterms() {
		this.loadOrders(true);
	}

	private checkBottom() {
		let bottomOfWindow =
			window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
		if (bottomOfWindow && this.hasMoreToLoad && !this.loading) {
			this.loadOrders(false);
		}
	}

	private async loadOrders(reload: boolean) {
		// Don't load while already loading and don't load empty states if that is already loaded.
		if (this.loading) {
			return;
		}
		try {
			this.loading = true;
			let from = 0;
			if (!reload) {
				from += this.orders.length;
			}
			let searchRequest = new OrderSearchRequestDto();
			searchRequest.orderSearchTerm = this.orderSearchTerm;
			searchRequest.articleSearchTerm = this.articleSearchTerm;
			searchRequest.sortingType = this.$store.state.orderSortingType;
			searchRequest.states = this.filterStates.map((state: any) => state.value);
			searchRequest.fertigerIds = this.filterFertiger.map((fertiger: any) => fertiger.id);
			searchRequest.quantityOfASinglePositionGreaterThen =
				this.quantityOfASinglePositionGreaterThen;
			searchRequest.numberOfPositionsLessThen = this.numberOfPositionsLessThen;

			const response = await httpClient().post(
				`CustomerOrder/GetCustomerOrders?from=${from}&to=${from + this.loadBatchSize}`,
				searchRequest
			);

			if (reload) {
				this.orders = response.data;
			} else {
				// Add new orders that weren't in the list before
				// Replace already existing orders to keep them updated
				response.data.forEach((newOrder: any) => {
					const orderIndex = this.orders.findIndex(
						(localOrder: CustomerOrderDto) => localOrder.orderId == newOrder.orderId
					);
					if (orderIndex >= 0) {
						this.orders.splice(orderIndex, 1, newOrder);
					} else {
						this.orders.push(newOrder);
					}
				});
			}
			this.hasMoreToLoad = response.data.length === this.loadBatchSize;
		} catch {
			console.log("Load orders failed.");
			this.$store.commit("setSnackbarErrorText", "Fehler beim laden der Aufträge.");
		} finally {
			this.loading = false;
		}
	}

	private manuallyLoadMoreOrders() {
		if (this.hasMoreToLoad && !this.loading) {
			this.loadOrders(false);
		}
	}

	private onPrepayInvoiceDialogClosed(success: boolean) {
		this.prepayInvoiceDialogOpen = false;
		if (success) {
			this.loadOrders(true);
		}
	}

	private openCreditNoteDialog(orderId: string, customerId: string) {
		this.creditNoteOrderId = Number(orderId);
		this.creditNoteCustomerId = Number(customerId);
		this.creditNoteDialogOpen = true;
	}

	private edit(orderId: string) {
		this.$router.push({ name: "editOrder", params: { orderId } });
	}

	private async downloadInvoice(orderId: string) {
		if (this.loading) {
			return;
		}
		try {
			this.loading = true;
			const response = await httpClient().get(
				`CustomerOrder/GetFinalInvoiceIdByOrderId?orderId=${orderId}`
			);
			await this.$store.dispatch("downloadInvoiceAsPdf", response.data);
		} catch {
			console.log("Failed to download invoice pdf.");
		} finally {
			this.loading = false;
		}
	}

	private async loadOrderCancellationRequests() {
		try {
			console.log("loading order cancellations...");
			const response = await httpClient().get("CustomerOrder/GetOrderCancellationRequests");
			this.$store.commit("setOrderCancellations", response.data);
		} catch (err) {
			console.log(`Fehler beim Laden der Stornierungsanfragen: ${err}`);
		}
	}

	private hasCancellationRequest(orderId: number) {
		return (
			this.orderCancellationRequests !== null &&
			this.orderCancellationRequests.some((o: any) => o.blexonOrderId == orderId)
		);
	}

	private onCancellationIconClick(orderId: number) {
		let requests = this.orderCancellationRequests.filter(
			(r: any) => r.blexonOrderId == orderId
		);
		if (requests.length < 1) return;
		this.currentCancellationRequest = requests[0];
		// If the Fertiger has to set progress, a dialog is shown
		if (this.currentCancellationRequest.state == 0) {
			this.showCancellationAtFertigerDialog = true;
		}
		// If the cost is already determined, show view
		else if (this.currentCancellationRequest.state == 1) {
			this.$router.push(`cancellationRequest/${orderId}`);
		}
	}

	private async getDeliveryNote(orderId: string) {
		try {
			this.loading = true;
			const response = await httpClient().get(
				`CustomerOrder/getDeliveryNote?orderId=${orderId}`,
				{
					responseType: "blob",
				}
			);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "Lieferschein zum Auftrag " + orderId + ".pdf");
			link.click();

			// Also download the labels (e.g. DHL) if there are any
			const countResponse = await httpClient().get(
				`CustomerOrder/getDeliveryNoteLabelCount?orderId=${orderId}`
			);
			for (let number = 0; number < countResponse.data; number++) {
				await this.getDeliveryNoteLabel(orderId, number);
			}
		} catch {
			console.error("Get delivery note failed.");
		} finally {
			this.loading = false;
		}
	}

	/**
	 * Downloads a single label of the delivery note.
	 * For Swiss Post, the first label is on the delivery note (no content), the others are additional delivery notes.
	 */
	private async getDeliveryNoteLabel(orderId: string, number: number) {
		try {
			const response = await httpClient().get(
				`CustomerOrder/getDeliveryNoteLabel?orderId=${orderId}&number=${number}`,
				{
					responseType: "blob",
				}
			);
			if (response.status != 200 || response.data.size === 0) {
				return;
			}
			const disposition: string = response.headers["content-disposition"] || "";
			const isDeliveryNote = disposition.includes("Lieferschein");
			const fileName = isDeliveryNote
				? `Lieferschein zum Auftrag ${orderId}_${number + 1}.pdf`
				: `Label ${orderId}_${number + 1}.pdf`;
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", fileName);
			link.click();
		} catch {
			this.$store.commit(
				"setSnackbarErrorText",
				`Fehler beim Download des Labels ${number + 1}.`
			);
		}
	}

	/**
	 * Blocks the creation of an invoice for the specified order.
	 */
	private async blockInvoice(orderId: string) {
		try {
			this.loading = true;
			const response = await httpClient().post(
				`CustomerOrder/BlockInvoice?orderId=${orderId}`
			);
			this.orders.filter((o) => o.orderId === orderId)[0].invoiceHasBeenBlocked = true;
		} catch {
			console.log("Block invoice failed.");
		} finally {
			this.loading = false;
		}
	}

	private async updateTransportPosition(orderId: string) {
		try {
			this.loading = true;
			const response = await httpClient().post(
				`CustomerOrder/UpdateTransportPosition?orderId=${orderId}`
			);
		} catch {
			console.log("Update transport position failed.");
		} finally {
			this.loading = false;
		}
	}

	/**
	 * Resets the state of the specified order in such a way
	 * that the invoice will be created. Either on demand or on the
	 * next nightly batch.
	 */
	private async releaseInvoice(orderId: string) {
		try {
			this.loading = true;
			const response = await httpClient().post(
				`CustomerOrder/ReleaseInvoice?orderId=${orderId}`
			);
			this.orders.filter((o) => o.orderId === orderId)[0].invoiceHasBeenBlocked = false;
		} catch {
			console.log("Release invoice failed.");
		} finally {
			this.loading = false;
		}
	}

	private async createInvoice(orderId: string) {
		try {
			this.loading = true;
			const response = await httpClient().post(
				`CustomerOrder/CreateInvoice?orderId=${orderId}`
			);
			this.orders.filter((o) => o.orderId === orderId)[0].customerOrderState =
				ErpCustomerOrderState.Fakturiert;
		} catch {
			console.log("Create invoice failed.");
		} finally {
			this.loading = false;
		}
	}

	private async updateDueDate(order: CustomerOrderDto, newDate: any) {
		try {
			this.loading = true;
			const response = await httpClient().post(
				`CustomerOrder/ChangeDeliveryDate?orderId=${order.orderId}&newDeliveryDate=${newDate}`
			);
			order.dueDate = newDate;
			this.$store.commit("setSnackbarText", `Lieferdatum wurde erfolgreich angepasst.`);
		} catch {
			this.$store.commit("setSnackbarErrorText", `Fehler beim Speicher des Lieferdatums.`);
		} finally {
			this.loading = false;
		}
	}

	private async changeFertiger(order: CustomerOrderDto) {
		try {
			this.loading = true;
			const fertigerResponse = await httpClient().post(
				`CustomerOrder/GetPossibleFertigers?orderId=${order.orderId}&regionId=${order.regionId}` +
					`&targetFertigerId=${order.fertigerId}`,
				order.parts
			);
			this.possibleFertigers = fertigerResponse.data;
			var fertiger = this.possibleFertigers.find(
				(f: any) => f.blexonFertigerId == order.fertigerId
			);
			if (fertiger == undefined) {
				// nicht möglich
				this.loading = false;
				this.showPossibleFertigersDialog = true;
				this.loadOrders(true);
				return;
			}
			const response = await httpClient().post(
				`CustomerOrder/ChangeFertiger?orderId=${order.orderId}&newFertigerId=${order.fertigerId}`
			);
			this.$store.commit("setSnackbarText", `Fertiger wurde erfolgreich angepasst.`);
		} catch {
			this.$store.commit("setSnackbarErrorText", `Fehler beim Speicher des neuen Fertigers.`);
		} finally {
			this.loading = false;
		}
	}

	private async sendFertigerMail(orderId: string) {
		try {
			this.loading = true;
			const response = await httpClient().post(
				`CustomerOrder/SendFertigerMailForOrder?orderId=${orderId}`
			);
			this.$store.commit("setSnackbarText", `Mail für Fertiger wurde erfolgreich gesendet.`);
		} catch {
			this.$store.commit("setSnackbarErrorText", `Fehler beim Senden des Fertigermails.`);
		} finally {
			this.loading = false;
		}
	}

	private openSendOrderConfirmationDialog(orderId: number) {
		this.currentOrderId = orderId;
		this.currentOrderSendDirectlyToCustomer = true;
		this.sendOrderConfirmationDialog = true;
	}

	private async sendOrderConfirmation() {
		try {
			if (this.currentOrderId <= 0) {
				throw new Error("Invalid order id");
			}
			this.loading = true;
			const response = await httpClient().post(
				`CustomerOrder/SendOrderConfirmationMail?orderId=${this.currentOrderId}&sendToCustomer=${this.currentOrderSendDirectlyToCustomer}`
			);
			this.$store.commit(
				"setSnackbarText",
				`Auftragsbestätiung wurde erfolgreich per Mail gesendet.`
			);
			this.currentOrderId = 0;
			this.sendOrderConfirmationDialog = false;
		} catch {
			this.$store.commit(
				"setSnackbarErrorText",
				`Fehler beim Senden der Auftragsbestätigung.`
			);
		} finally {
			this.loading = false;
		}
	}

	private openReleaseOrderDialog(orderId: number, fertigerId: number) {
		this.currentOrderId = orderId;
		this.currentOrderFertigerId = fertigerId;
		this.currentOrderSendConfirmation = true;
		this.currentOrderSendDirectlyToCustomer = true;
		this.releaseOrderDialog = true;
	}

	private async releaseOrderandReload() {
		await this.releaseOrder();
		await this.loadOrders(true);
	}

	private async releaseOrder() {
		try {
			if (this.currentOrderId <= 0 || this.currentOrderFertigerId <= 0) {
				console.log(
					`Order id ${this.currentOrderId} or fertiger id ${this.currentOrderFertigerId} are invalid.`
				);
				throw new Error("Invalid order or fertiger ids");
			}
			this.loading = true;
			const call =
				`CustomerOrder/ReleaseOrder?orderId=${this.currentOrderId}` +
				`&fertigerId=${this.currentOrderFertigerId}` +
				`&sendConfirmation=${this.currentOrderSendConfirmation}` +
				`&sendToCustomer=${this.currentOrderSendDirectlyToCustomer}`;
			const response = await httpClient().post(call);
			this.$store.commit("setSnackbarText", `Auftrag wurde freigegeben.`);
			this.currentOrderId = 0;
			this.currentOrderFertigerId = 0;
			this.releaseOrderDialog = false;
		} catch {
			this.$store.commit("setSnackbarErrorText", `Fehler beim freigeben des Auftrags.`);
		} finally {
			this.loading = false;
		}
	}

	private openCancelOrderdialog(orderId: string, fertigerId: number) {
		this.currentCancelOrderId = orderId;
		this.currentCancelOrderFertigerId = fertigerId;
		this.cancelOrderDialog = true;
	}

	private async cancelOrder() {
		try {
			this.loading = true;
			const response = await httpClient().post(
				`CustomerOrder/CancelOrder?orderId=${this.currentCancelOrderId}&fertigerId=${this.currentCancelOrderFertigerId}`
			);
			this.$store.commit("setSnackbarText", `Auftrag wurde storniert.`);
			this.cancelOrderDialog = false;
			this.currentCancelOrderId = "";
			this.currentCancelOrderFertigerId = 0;
			await this.loadOrders(true);
		} catch {
			this.$store.commit("setSnackbarErrorText", `Fehler beim Stornieren des Auftrags.`);
		} finally {
			this.loading = false;
		}
	}

	private async extendComplaintDeadline(orderId: number) {
		try {
			this.loading = true;
			await httpClient().post(`CustomerOrder/ExtendComplaintDeadline?orderId=${orderId}`);
			this.$store.commit("setSnackbarText", "Beanstandungsfrist verlängert.");
		} catch {
			this.$store.commit(
				"setSnackbarErrorText",
				"Fehler beim verlängern der Beanstandungsfrist."
			);
		} finally {
			this.loading = false;
		}
	}

	private getPartsAndPositions(order: any) {
		return order.parts.concat(order.positions);
	}

	private getStatusIcon(status: ErpCustomerOrderState) {
		return status.toString();
	}

	/**
	 * Returns the color for the state of the specified customer order.
	 * The state is based on the production order state.
	 */
	private getStateColor(customerOrder: CustomerOrderDto) {
		switch (customerOrder.customerOrderState) {
			case ErpCustomerOrderState.Gueltig:
			case ErpCustomerOrderState.Freigegeben:
			case ErpCustomerOrderState.Fertig:
			case ErpCustomerOrderState.InStornierung:
				return "grey";
			case ErpCustomerOrderState.Geliefert:
			case ErpCustomerOrderState.Fakturiert:
			case ErpCustomerOrderState.Abgeschlossen:
			case ErpCustomerOrderState.Storniert:
				return "green";
			case ErpCustomerOrderState.CreditOverdrawn:
				if (customerOrder.invoiceIds && customerOrder.invoiceIds.length > 0) {
					return "orange";
				} else {
					return "red";
				}
		}
	}

	private changeSort(column: string, sortable: boolean) {
		if (sortable) {
			let newSort: OrderSortingType;
			if (this.orderSorting.sortByColumn === column) {
				newSort = this.orderSorting.sortDescending
					? this.$store.state.orderSortingType - 1
					: this.$store.state.orderSortingType + 1;
			} else {
				newSort = this.getSortTypeFromColumn(column);
			}
			this.$store.commit("setOrderSorting", newSort);
			this.loadOrders(true);
		}
	}

	private get orderSorting() {
		let descending: boolean = false;
		let column: string = "receivedAt";
		let currentSortingType: OrderSortingType = this.$store.state.orderSortingType;
		switch (currentSortingType) {
			case OrderSortingType.CustomerIdAscending: {
				descending = false;
				column = "customerId";
				break;
			}
			case OrderSortingType.CustomerIdDescending: {
				descending = true;
				column = "customerId";
				break;
			}
			case OrderSortingType.StateAscending: {
				descending = false;
				column = "customerOrderState";
				break;
			}
			case OrderSortingType.StateDescending: {
				descending = true;
				column = "customerOrderState";
				break;
			}
			case OrderSortingType.NameAscending: {
				descending = false;
				column = "customerName";
				break;
			}
			case OrderSortingType.NameDescending: {
				descending = true;
				column = "customerName";
				break;
			}
			case OrderSortingType.OrderIdAscending: {
				descending = false;
				column = "orderId";
				break;
			}
			case OrderSortingType.OrderIdDescending: {
				descending = true;
				column = "orderId";
				break;
			}
			case OrderSortingType.OrderDateAscending: {
				descending = false;
				column = "receivedAt";
				break;
			}
			case OrderSortingType.OrderDateDescending: {
				descending = true;
				column = "receivedAt";
				break;
			}
			case OrderSortingType.ShippingDateAscending: {
				descending = false;
				column = "dueDate";
				break;
			}
			case OrderSortingType.ShippingDateDescending: {
				descending = true;
				column = "dueDate";
				break;
			}
			case OrderSortingType.FertigerAscending: {
				descending = false;
				column = "fertigerId";
				break;
			}
			case OrderSortingType.FertigerDescending: {
				descending = true;
				column = "fertigerId";
				break;
			}
		}
		return {
			sortDescending: descending,
			sortByColumn: column,
		};
	}

	private isGestoertState(customerOrder: CustomerOrderDto) {
		return customerOrder.customerOrderState == ErpCustomerOrderState.CreditOverdrawn;
	}

	private async editAddress(orderId: string, addressType: number) {
		try {
			this.currentEditedOrderId = parseInt(orderId);
			this.currentEditedAddressType = addressType as AddressType;
			let call = "";
			if (addressType == AddressType.OrderInvoice) {
				call = `CustomerOrder/GetOrderInvoiceAddress?orderId=${orderId}`;
			} else if (addressType == AddressType.OrderDelivery) {
				call = `CustomerOrder/GetOrderDeliveryAddress?orderId=${orderId}`;
			} else {
				throw "Invalid address type";
			}
			const response = await httpClient().get(call);
			this.currentEditedAddress = response.data;
			this.editAddressDialog = true;
		} catch (err) {
			console.log(`Adresse konnte nicht geladen werden. ${err}`);
		}
	}

	private goToCustomer(customerId: string) {
		this.$router.push({ name: "customerDetail", params: { customerId } });
	}

	private async openTrackingLink(orderId: string) {
		try {
			const response = await httpClient().get(
				`CustomerOrder/GetTrackingLink?orderId=${orderId}`
			);
			let url = new URL(response.data); // This fails if the argument is not a valid URL
			this.currentTrackingLink = response.data;
			this.trackingLinkDialog = true;
		} catch (err) {
			console.log(`Error while getting the tracking link for order ${orderId}.`, err);
			this.$store.commit(
				"setSnackbarErrorText",
				"Sendungslink konnte nicht geöffnet werden."
			);
		}
	}

	private async showOrderCalculation(order: any) {
		try {
			var groupBy = (xs: any, key: any) => {
				return xs.reduce((rv: any, x: any) => {
					(rv[x[key]] = rv[x[key]] || []).push(x);
					return rv;
				}, {});
			};

			this.currentOrderWorkSteps = [];
			const response = await httpClient().get(
				`Calculation/GetWorkSteps?orderId=${order.orderId}&calculationId=0`
			);
			this.currentOrderWorkSteps = Object.entries(groupBy(response.data, "articleId"));
			this.currentOrderArticleMaterials.clear();
			this.currentOrderWorkSteps.forEach((step: any) => {
				let article = order.parts.filter((p: any) => p.articleId === parseInt(step[0]))[0];
				this.currentOrderArticleMaterials.set(step[0], article.materialBezeichnung);
			});
			this.showOrderWorkStepsDialog = true;
		} catch (err) {
			console.log(`Error while getting the worksteps for order ${order.orderId}.`, err);
			this.$store.commit(
				"setSnackbarErrorText",
				"Arbeitsschritte konnten nicht geladen werden."
			);
		}
	}

	/**
	 * Gets the total of all positions of the specified order
	 */
	private getTotal(order: CustomerOrderDto) {
		var total = 0;
		for (const position of order.positions) {
			total += position.menge * position.customerPricePerPart;
		}
		for (const position of order.parts) {
			total += position.menge * position.customerPricePerPart;
		}
		return total;
	}

	private getOrderTotalWeight(order: CustomerOrderDto) {
		return order.parts
			.filter((p) => !p.includedSubarticleIds || p.includedSubarticleIds.length == 0)
			.reduce(
				(partialSum: number, part: PartDto) => (partialSum += part.gewicht * part.menge),
				0
			);
	}

	/**
	 * Gets the total of all loaded orders
	 */
	private getTotalOfAllOrders() {
		var regions: any = [];
		for (const order of this.orders) {
			if (order.customerOrderState !== ErpCustomerOrderState.Storniert) {
				var region = regions.find((r: any) => r.id === order.regionId);
				if (region == null) {
					region = {
						id: order.regionId,
						name: order.regionId == 1 ? "Schweiz / Liechtenstein" : "Deutschland",
						währung: order.regionId == 1 ? "CHF" : "EUR",
						total: 0,
					};
					regions.push(region);
				}
				region.total += this.getTotal(order);
			}
		}
		var total = "Total: ";
		for (const region of regions) {
			total += `${region.name}: ${region.total.toFixed(2)} ${region.währung} | `;
		}
		return total.substring(0, total.length - 3);
	}

	private getCurrentDate() {
		return moment().toDate();
	}

	getSortTypeFromColumn(column: string) {
		switch (column) {
			case "customerId": {
				return OrderSortingType.CustomerIdAscending;
			}
			case "customerOrderState": {
				return OrderSortingType.StateAscending;
			}
			case "customerName": {
				return OrderSortingType.NameAscending;
			}
			case "orderId": {
				return OrderSortingType.OrderIdAscending;
			}
			case "receivedAt": {
				return OrderSortingType.OrderDateAscending;
			}
			case "dueDate": {
				return OrderSortingType.ShippingDateAscending;
			}
			case "fertigerId": {
				return OrderSortingType.FertigerAscending;
			}
			default: {
				return OrderSortingType.OrderDateAscending;
			}
		}
	}

	/**
	 * Returns the tooltip text explaining the state of the specified customer order.
	 * The state is based on the production order state.
	 */
	private getStateText(customerOrder: CustomerOrderDto) {
		switch (customerOrder.customerOrderState) {
			case ErpCustomerOrderState.Gueltig:
				return "Gültig";
			case ErpCustomerOrderState.Freigegeben:
				return "Freigegeben";
			case ErpCustomerOrderState.Fertig:
				return "Fertig";
			case ErpCustomerOrderState.Geliefert:
				return "Geliefert";
			case ErpCustomerOrderState.Fakturiert:
				return "Fakturiert";
			case ErpCustomerOrderState.Abgeschlossen:
				return "Abgeschlossen";
			case ErpCustomerOrderState.Storniert:
				return "Storniert";
			case ErpCustomerOrderState.CreditOverdrawn:
				if (customerOrder.invoiceIds && customerOrder.invoiceIds.length > 0) {
					return "Vorausrechnung gesendet";
				} else {
					return "Kreditlimit überschritten";
				}
			case ErpCustomerOrderState.InStornierung:
				return "In Stornierung";
		}
	}

	private hasPrepayInvoice(customerOrder: CustomerOrderDto): boolean {
		if (!customerOrder.invoiceIds || customerOrder.invoiceIds.length === 0) {
			return false;
		}
		const state = customerOrder.customerOrderState;
		if (
			state === ErpCustomerOrderState.Fakturiert ||
			state === ErpCustomerOrderState.Abgeschlossen
		) {
			return customerOrder.invoiceIds.length > 1;
		}
		return true;
	}

	private getStateIcon(customerOrder: CustomerOrderDto) {
		switch (customerOrder.customerOrderState) {
			case ErpCustomerOrderState.Gueltig:
				return "bookmarks";
			case ErpCustomerOrderState.Freigegeben:
				return "gavel";
			case ErpCustomerOrderState.Fertig:
				return "gavel";
			case ErpCustomerOrderState.Geliefert:
				return "local_shipping";
			case ErpCustomerOrderState.Fakturiert:
				return "attach_money";
			case ErpCustomerOrderState.Abgeschlossen:
				return "check_circle";
			case ErpCustomerOrderState.Storniert:
				return "delete_forever";
			case ErpCustomerOrderState.CreditOverdrawn:
				return "warning";
			case ErpCustomerOrderState.InStornierung:
				return "auto_delete";
		}
	}

	private GetArticleFaceString(enumValue: number) {
		return this.articleFaceTypes.filter((type: IArticleFaceType) => type.value == enumValue)[0]
			.text;
	}
	private GetStructureString(enumValue: number) {
		return this.powderStructures.filter((type: IPowderStructure) => type.value == enumValue)[0]
			.text;
	}
	private GetFinishString(enumValue: number) {
		return this.powderFinishes.filter((type: IPowderFinish) => type.value == enumValue)[0].text;
	}
	private getFeatureString(article: ArticleDto): string {
		let featureTexts: string[] = [];
		const featureDtoTexts = article.featureDtos.map((f) => `${f.count} * ${f.formVorlageText}`);
		featureTexts.push(...featureDtoTexts);
		if (article.hasEngravings) {
			featureTexts.push("Gravur");
		}
		return featureTexts.join(" | ");
	}

	private isAssembly(position: PartDto) {
		return position.includedSubarticleIds && position.includedSubarticleIds.length > 0;
	}

	private getPositionNumber(order: CustomerOrderDto, position: PartDto) {
		var parentPosition = order.parts.find((p) =>
			p.includedSubarticleIds.some((id) => id === position.articleId)
		);
		if (parentPosition !== undefined) {
			return `${parentPosition.position}.${position.position}`;
		}
		return position.position;
	}

	private getZincCoatingText(zincCoating: ZincCoating) {
		return getZincCoatingText(zincCoating);
	}
}
